import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import RapidExplainer from "@/components/RapidExplainer";
import Conditions from "@/components/Conditions";
import Locations from "@/components/Locations";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Testimonials from "@/components/Testimonials";

const Home = () => {
  return (
    <div data-testid="home-page" className="bg-white">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <RapidExplainer />
        <Conditions />
        <Testimonials />
        <Locations />
        <FAQ />
        <Contact />
      </main>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
